<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 4.7H4.667C2.826 4.7 1.333 6.192 1.333 8.033c0 1.841 1.493 3.334 3.334 3.334h1.333c1.841 0 3.333-1.493 3.333-3.334m1.334 3.334h.333c1.841 0 3.333-1.493 3.333-3.334 0-1.84-1.492-3.333-3.333-3.333h-1.333c-1.841 0-3.334 1.492-3.334 3.333"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
